import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/onDemandRevenueSagas";

export const UpdateButtons = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.onDemandRevenue.filtersDirty);
  const showValidationMessage = useSelector((state) => state.onDemandRevenue.showValidationMessage);
  const selectedSubscriptions = useSelector(
    (state) => state.onDemandRevenue.selectedFilters.selectedSubscriptions
  );

  const handleReset = () => {
    dispatch(actionCreators.resetFilters());
  };

  const handleUpdate = () => {
    if (!selectedSubscriptions.length) {
      dispatch(actionCreators.setShowValidationMessage(true));
      return;
    }

    dispatch(actionCreators.updateChart());
  };

  return filtersDirty ? (
    <>
      <button className="submit" onClick={handleUpdate}>
        Update
      </button>

      <button className="submit reset" onClick={handleReset}>
        Reset
      </button>
      {showValidationMessage && !selectedSubscriptions.length ? (
        <div className="validation-message">Please, select at least one subscription.</div>
      ) : null}
    </>
  ) : (
    ""
  );
};
